import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	flex: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	box: {
		width: '90vw',
		maxWidth: 500,
		minHeight: 140,
	},
	title: {
		fontSize: 28,
	},
}));

export default useStyles;
